import React from 'react';
import { bonos, bonosTotalValue } from '../data/bonos';
import { Emoji } from './Emoji';
export function Bonos() {
  return <section className="w-full bg-white py-14 sm:py-16" data-id="element-16" data-mp="2hdcya1siix0d">
      <div className="mx-auto w-full max-w-content px-4 text-center sm:px-6" data-id="element-17" data-mp="2leewcfap130r">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase leading-[1.08] tracking-tight text-ink-900 sm:gap-3" data-id="element-18" data-mp="2lcbw72ftttib">
          <Emoji symbol="🎁" className="text-3xl sm:text-4xl" data-id="element-19" data-mp="3032pkex2h0nj" />
          Los 6 Bonos Estratégicos
        </h2>
        <p className="mt-3 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-gold-700 sm:text-sm" data-id="element-20" data-mp="352fc0yk105pl">
          Siempre incluidos
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-ink-500 sm:text-[15px]" data-id="element-21" data-mp="392y6l0dazpvh">
          Porque el sistema no termina en las recetas.
        </p>

        <ul className="mt-10 grid gap-4 text-left sm:gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1eqrjb374ximt">
          {bonos.map(bono => <li key={bono.index} className="h-full" data-id="element-23" data-mp="3e5c224h666ie">
              <article className="flex h-full flex-col rounded-2xl border-2 border-gold-400 bg-gold-100 px-5 py-5 shadow-card sm:px-6" data-id="element-24" data-mp="39cr9t7dww1gz">
                <p className="font-display text-3xl font-black leading-none text-gold-600" data-id="element-25" data-mp="34eprioob866k">
                  {bono.index}
                </p>
                <p className="mt-3 inline-flex items-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-700" data-id="element-26" data-mp="xhag71epacw">
                  <Emoji symbol="🎁" data-id="element-27" data-mp="3s53jygat471o" />
                  Bono {Number(bono.index)}
                </p>
                <h3 className="mt-3 flex items-center gap-2 font-display text-[15px] font-extrabold uppercase leading-snug tracking-tight text-ink-900 sm:text-base" data-id="element-28" data-mp="3n34hr9qszg6b">
                  <Emoji symbol={bono.emoji} data-id="element-29" data-mp="2bpsmvod0u7wa" />
                  <span className="min-w-0" data-id="element-30" data-mp="2bqtvlm6keiau">{bono.title}</span>
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-ink-700 sm:text-[14px]" data-id="element-31" data-mp="26ow8ggv1n3cm">
                  {bono.description}
                </p>
                <p className="mt-auto flex flex-wrap items-center gap-3 pt-6" data-id="element-32" data-mp="12sc12nrlrno5">
                  <span className="text-sm text-ink-400 line-through" data-id="element-33" data-mp="12q9ao2mjfsiw">
                    {bono.value}
                  </span>
                  <span className="rounded-full bg-gold-600 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-34" data-mp="tre4gqjhuifl">
                    Gratis
                  </span>
                </p>
              </article>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border-2 border-gold-400 bg-white px-5 py-6 shadow-card sm:px-7 sm:py-7" data-id="element-35" data-mp="62bfsyqfzpbl">
          <p className="font-display text-base font-bold text-ink-900 sm:text-lg" data-id="element-36" data-mp="b0mlcx9pfdo0">
            Valor total de los 6 bonos
          </p>
          <p className="mt-2 font-display text-2xl text-ink-400 line-through sm:text-3xl" data-id="element-37" data-mp="3sab9qrwjktoe">
            {bonosTotalValue}
          </p>
          <p className="mt-2 font-display text-lg font-extrabold text-gold-700 sm:text-xl" data-id="element-38" data-mp="3dmkq7w3aqjo5">
            → Gratis con tu MegaPack
          </p>
        </div>
      </div>
    </section>;
}